import data from "./arcanes.json";

export const CARD_BACK = data.base + data.back;

export const ARCANES = data.cards.map((c) => ({ ...c, image: data.base + c.file }));

export const ARCANE_BY_SLUG = ARCANES.reduce((acc, a) => ((acc[a.slug] = a), acc), {});
export const ARCANE_BY_ID = ARCANES.reduce((acc, a) => ((acc[a.id] = a), acc), {});

export function shuffledDeck() {
  const d = [...ARCANES];
  for (let i = d.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [d[i], d[j]] = [d[j], d[i]];
  }
  return d;
}
